export const markupValidationMsg =
  "The buyer's price cannot be more than twice the ISV price"
